export default "__VITE_ASSET__B8wWV1fB__"